import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Languages from "@/components/Languages";
import Method from "@/components/Method";
import Pricing from "@/components/Pricing";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <SmoothScroll>
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <About />
            <Languages />
            <Method />
            <Pricing />
            <Contact />
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </SmoothScroll>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
